import FilterNoResults from './FilterNoResults'

export default FilterNoResults
// eslint-disable-next-line import/export
export * from './FilterNoResults'
